import React from 'react';
import { CTAButton } from './CTAButton';
export const FinalCTA: React.FC = () => {
  return <section className="bg-gradient-to-br from-green-dark via-green-mid to-brown-dark text-white py-20 px-5 text-center" data-id="element-84" data-mp="3ucnh00j9dvxq">
      <h2 className="text-[clamp(26px,4.5vw,50px)] mb-[15px] leading-[1.2] max-w-[800px] mx-auto" data-id="element-85" data-mp="c7tvnlnquuuk">
        El precio cierra pronto.
        <br data-id="element-86" data-mp="83vxbd68to2k" />
        <em className="text-gold-main not-italic" data-id="element-87" data-mp="87jsshv90kjx">
          Tu terreno no puede esperar más.
        </em>
      </h2>
      <p className="text-[clamp(15px,2vw,18px)] text-[#C8E6C9] font-sans max-w-[620px] mx-auto mb-10 leading-[1.8]" data-id="element-88" data-mp="h656nzprzbed">
        Hay dos tipos de personas: las que siguen soñando con su casa de barro
        año tras año y las que decidieron tener el sistema correcto para empezar
        esta semana. ¿De qué lado querés estar?
      </p>

      <div className="bg-white/5 border border-gold-main/20 rounded-2xl py-[35px] px-10 max-w-[450px] mx-auto mb-[30px] md:py-[28px] md:px-[25px]" data-id="element-89" data-mp="14whmdwr9icfi">
        <p className="text-white/50 text-lg font-sans line-through mb-1.5" data-id="element-90" data-mp="zuij0mvivfik">
          Valor real del pack: $56.000
        </p>
        <div data-id="element-91" data-mp="2h37xyz9qymzm">
          <span className="text-gold-main text-[26px] align-top mt-3 inline-block" data-id="element-92" data-mp="2h4srclkbrzvw">
            $
          </span>
          <span className="text-[60px] font-black text-white leading-none" data-id="element-93" data-mp="2m21dsyciaq2y">
            19.999
          </span>
        </div>
        <p className="text-[13px] text-white/60 font-sans mt-2" data-id="element-94" data-mp="2qzufbe2v6vww">
          ARS · Pago único · Acceso inmediato y de por vida
        </p>
      </div>

      <CTAButton href="#precio" data-id="element-95" data-mp="301tzugd38i4l">🏠 → QUIERO MI MEGA PACK TIERRA VIVA</CTAButton>

      <p className="text-[13px] text-[#A5D6A7] font-sans mt-[15px] leading-relaxed" data-id="element-96" data-mp="34tlsqxjpuzxw">
        🔒 Pago 100% seguro &nbsp;|&nbsp; ⚡ Acceso en 5 minutos &nbsp;|&nbsp;
        🛡️ Garantía 7 días sin preguntas
        <br data-id="element-97" data-mp="3es1j2yax656c" />
        💳 Mercado Pago | Tarjeta | Transferencia
      </p>

      <p className="text-[clamp(15px,2vw,19px)] text-[#A5D6A7] font-sans italic mt-[30px]" data-id="element-98" data-mp="3eposjwr3imho">
        🌿 "La tierra te espera. El sistema ya está listo."
      </p>
    </section>;
};